import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ProblemFacade } from 'src/app/store/problem/facade';
import { getTimeLeft, ProblemModel } from 'src/app/store/problem/model';
import { confirm } from 'devextreme/ui/dialog';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-problems',
  templateUrl: './problems.component.html',
  styleUrls: ['./problems.component.scss'],
  host: {
    class: 'p-4',
  },
  standalone: false,
})
export class ProblemsComponent implements OnInit {
  private router = inject(Router);
  translate = inject(TranslateService);
  private problemFacade = inject(ProblemFacade);
  private titleService = inject(Title);

  problems$: Observable<ProblemModel[]>;

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    this.problems$ = this.problemFacade.allProblems$;
  }

  createProblem() {
    //this.router.navigate(['/problem', '0']);
    this.router.navigate(['admin/problem', '0']);
  }

  editProblem(event, problemId: number) {
    event.event.preventDefault();
    event.event.stopPropagation();

    //this.router.navigate(['/problem', problemId]);
    this.router.navigate(['admin/problem', problemId]);
  }

  async deleteProblem(event, problemId: number) {
    event.event.preventDefault();
    event.event.stopPropagation();

    let captionDelete = await this.translate.get('DELETE').toPromise();
    let textDelete = await this.translate.get('CONFIRM_DELETE').toPromise();

    const confirmDelete = await confirm(textDelete, captionDelete).then();
    if (confirmDelete) {
      this.problemFacade.deleteProblem(problemId);
    }
  }

  getTimeLeft(problem: ProblemModel) {
    return getTimeLeft(problem);
  }

  convertImage(problem: ProblemModel): any {
    return this.problemFacade.convertImage(problem);
  }
}
